module.exports = __webpack_public_path__ + "img/data_overview_map_right.972ca6a2.png";